export const _almaCookiesSettings = createInjector('AlmaCookieSettings', () => {
  function openSettings() {
    const trigger = document.getElementById('alma-cookie-settings');
    if (trigger) {
      trigger.click();
    }
  }

  return reactive({
    openSettings,
  });
});
